// extracted by mini-css-extract-plugin
module.exports = {"swiper":"_h6","swiper_element":"_h7","slider":"_h8"};